export const toAddr = (a) => ({
  business: a.business || "", line1: a.line1 || "", line2: a.line2 || "", city: a.city || "", postcode: a.postcode || "",
  lat: a.lat, lng: a.lng, contact_name: a.contact_name || "", contact_phone: a.contact_phone || "",
  label: a.address_label || a.label || [a.business, a.line1, a.city, a.postcode].filter(Boolean).join(", "),
  id: a.id || `addr:${a.line1}`,
});

export const PICKUP_WINDOWS = [
  { v: "Anytime (business hours)", l: "Anytime (business hours)" },
  { v: "Morning (8am–12pm)", l: "Morning (8am–12pm)" },
  { v: "Afternoon (12pm–4pm)", l: "Afternoon (12pm–4pm)" },
  { v: "Late (4pm–6pm)", l: "Late (4pm–6pm)" },
];

export const CBR_WINDOW = "Morning (8:30am–12pm)";
export const CBR_DAYS = [0, 1, 2, 3, 4, 5, 6]; // JS getDay — every day
export const CBR_NOTE = "Canberra & Queanbeyan pickups run every day, mornings (8:30am–12pm) — delivered the same afternoon to Cooma and the Jindabyne area (Jindabyne, East Jindabyne, Berridale, Dalgety, Moonbah, Kalkite and surrounds).";
export const CBR_AREA = "Cooma and the Jindabyne area (Jindabyne, East Jindabyne, Berridale, Dalgety, Moonbah, Kalkite and surrounds)";
export const CBR_AREA_MSG = `Canberra & Queanbeyan pickups are delivered the same afternoon to ${CBR_AREA} — please choose a drop-off there.`;
// Admin (or an admin troubleshooting as a customer) may quote/book outside the run area
export const canOverrideArea = (user) => user?.role === "admin" || !!localStorage.getItem("kc_admin_backup");
const CBR_PICKUP_TOWNS = ["canberra", "queanbeyan", "jerrabomberra"];
const CBR_DELIVERY_TOWNS = ["cooma", "berridale", "jindabyne", "east jindabyne", "dalgety", "moonbah", "kalkite", "crackenback", "thredbo", "perisher", "hill top", "hilltop", "avonside", "beloka", "maffra", "bobundara", "rocky plain", "nimmo", "eucumbene", "braemar bay", "ingebirah", "grosses plain", "wollondibby", "tinderry", "numbla vale", "snowy plain", "polo flat", "middlingbank", "bunyan", "the brothers", "arable", "rhine falls", "jimenbuen"];
const CBR_DELIVERY_POSTCODES = [2627, 2628, 2630];
export const isCbrPickup = (a) => {
  if (!a) return false;
  const city = (a.city || "").toLowerCase();
  if (CBR_PICKUP_TOWNS.some((t) => city.includes(t))) return true;
  const pc = parseInt(a.postcode, 10) || 0;
  return (pc >= 2600 && pc <= 2620) || (pc >= 2900 && pc <= 2914);
};
export const isCbrDeliveryTown = (a) => {
  if (!a) return false;
  const city = (a.city || "").toLowerCase();
  if (CBR_DELIVERY_TOWNS.some((t) => city.includes(t))) return true;
  return CBR_DELIVERY_POSTCODES.includes(parseInt(a.postcode, 10) || 0);
};
export const isCbrDay = (dstr) => !!dstr && CBR_DAYS.includes(new Date(`${dstr}T00:00:00`).getDay());

export const CONF = {
  high: { l: "High confidence", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  medium: { l: "Medium confidence", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  low: { l: "Low confidence", cls: "bg-red-100 text-red-800 border-red-200" },
};

export const SIZES = [
  { v: "small", l: "Small — under 30cm, under 12.5kg", max: 12.5 },
  { v: "medium", l: "Medium — 30–50cm, under 16.5kg", max: 16.5 },
  { v: "large", l: "Large — over 50cm, under 22.5kg", max: 22.5 },
];
export const SERVICES = [
  { v: "standard", l: "Standard", d: "Best effort — usually 1–3 days." },
  { v: "express", l: "Priority", d: "Your package is sent via the quickest normal means." },
  { v: "sameday", l: "Urgent", d: "A dedicated driver makes your job happen as soon as humanly possible — you need it now, so the sooner the better." },
];
export const serviceLabel = (v) => SERVICES.find((s) => s.v === v)?.l || v;
export const MAX_WEIGHT = 22.5;
const SIZE_ORDER = ["small", "medium", "large"];
export const sizeIdx = (s) => SIZE_ORDER.indexOf(s);
export const minSizeForWeight = (w) => {
  const n = parseFloat(w) || 0;
  if (n > 16.5) return "large";
  if (n > 12.5) return "medium";
  return "small";
};
export const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
export const newItem = () => ({ uid: (crypto.randomUUID ? crypto.randomUUID() : String(Math.random())), size: "small", quantity: 1, weight: "1", desc: "", sizeTouched: false });
export const withUid = (o) => ({ uid: (crypto.randomUUID ? crypto.randomUUID() : String(Math.random())), ...o });
